import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Checkbox } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UserModal from "./UserModal";
import EditUserModal from "./EditUserModal";
import DeleteConfirmation from "./DeleteConfirmation";

import { FormControl, OutlinedInput, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import { API_BASE_URL } from "../../../apiConfig";
import AddUserModal from "./AddUserModal";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";

export default function ManageUsers() {
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [addUserModalOpen, setAddUserModalOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [nameToDelete, setNameToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const fetchData = async (page, searchQuery) => {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token not available. Please log in.");
    }

    try {
      // الطلب الأساسي
      const response = await axios.get(
        `${API_BASE_URL}User/GetAllByPage/${page + 1}/${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.user && response.data.user.length > 0) {
        const formattedData = response.data.user.map((user) => ({
          id: user.id,
          userName: user.userName,
        }));

        setRows(formattedData);
        setTotalRecords(response.data.allRecord);
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    } catch (error) {
      // إذا كان التوكن منتهي الصلاحية
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const response = await axios.get(
            `${API_BASE_URL}User/GetAllByPage/${page + 1}/${searchQuery}`,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          if (response.data.user && response.data.user.length > 0) {
            const formattedData = response.data.user.map((user) => ({
              id: user.id,
              userName: user.userName,
            }));

            setRows(formattedData);
            setTotalRecords(response.data.allRecord);
          } else {
            setRows([]);
            setTotalRecords(0);
          }
        } catch (retryError) {
          console.error("Retry failed:", retryError);
          setRows([]);
          setTotalRecords(0);
        }
      } else {
        console.error("Error fetching data:", error);
        setRows([]);
        setTotalRecords(0);
      }
    }
  };

  const handlePaginationChange = (paginationModel) => {
    setCurrentPage(paginationModel.page);
  };

  const handleSearch = () => {
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleClear = () => {
    setSearchValue("");
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // useEffect(() => {
  //   fetchData(currentPage, searchValue);
  // }, [currentPage, triggerSearch]);

  // useEffect(() => {
  //   fetchData(currentPage, searchValue);
  // });

  useEffect(() => {
    fetchData(currentPage || 0, searchValue || "");
  }, [currentPage, triggerSearch, refreshFlag]);

  const handleDeleteClick = (id, name) => {
    setUserIdToDelete(id);
    setNameToDelete(name);
    setShowConfirm(true);
  };

  const handleConfirmDelete = () => {
    const token = localStorage.getItem("token");

    if (userIdToDelete === 1) {
      return;
    }

    axios
      .delete(`${API_BASE_URL}User/Delete/${userIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        alert("تم حذف المشرف بنجاح.");
        setShowConfirm(false);
        setUserIdToDelete(null);
        fetchData(currentPage, searchValue);
      })
      .catch(async (error) => {
        if (error.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بالتوكن الجديد
            axios
              .delete(`${API_BASE_URL}User/Delete/${userIdToDelete}`, {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              })
              .then(() => {
                alert("تم حذف المشرف بنجاح.");
                setShowConfirm(false);
                setUserIdToDelete(null);
                fetchData(currentPage, searchValue);
              })
              .catch((retryError) => {
                // alert("Retry failed: " + retryError.message);
              });
          } catch (err) {}
        } else {
          //  console.error("Error deleting user:", error);
          alert("حدث خطأ أثناء محاولة حذف المشرف.");
        }
      });
  };

  const refreshData = () => {
    // fetchData(currentPage, searchValue);
    setRefreshFlag((prev) => !prev);
  };
  const handleCancelDelete = () => {
    setShowConfirm(false);
    setUserIdToDelete(null);
  };

  const handleEdit = (id) => {
    setSelectedUserId(id);
    setEditUserModalOpen(true);
  };

  const handleView = (id) => {
    setSelectedUserId(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedUserId(null);
  };

  const handleAddRow = () => {
    setAddUserModalOpen(true);
  };

  const handleCloseAddUserModal = () => {
    fetchData(currentPage, searchValue);
    refreshData();
    setAddUserModalOpen(false);
  };

  const handleCloseEditUserModal = () => {
    fetchData(currentPage, searchValue);
    refreshData();
    setEditUserModalOpen(false);
  };

  const columns = [
    {
      field: "actions",
      headerName: "الإجراءات",
      flex: 1,
      renderCell: (params) => (
        <>
          <IconButton
            color="error"
            onClick={() =>
              handleDeleteClick(params.row.id, params.row.userName)
            }
          >
            <DeleteIcon />
          </IconButton>
          <IconButton onClick={() => handleEdit(params.row.id)}>
            <EditIcon sx={{ color: "green" }} />
          </IconButton>
          <IconButton color="primary" onClick={() => handleView(params.row.id)}>
            <VisibilityIcon />
          </IconButton>
        </>
      ),
      headerAlign: "right",
      align: "right",
    },
    {
      field: "userName",
      headerName: "اسم المشرف",
      flex: 7.5,
      headerAlign: "right",
      align: "right",
    },
  ];

  return (
    <div
      dir={"rtl"}
      style={{
        color: "white",
        maxWidth: "100%",
        maxHeight: "100%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      <h3>إدارة المشرفين - الاذونات</h3>
      <div
        dir={"ltr"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "7%",
        }}
      >
        <div dir="rtl" style={{ width: "50%" }}>
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <OutlinedInput
              placeholder="ابحث بأسم المشرف"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={handleKeyDown}
              sx={{
                color: "#5b5b5c",
                backgroundColor: "#fff",
                borderRadius: "4px",
                "& input": { color: "#303031" },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#0064b7",
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchValue && (
                    <IconButton onClick={handleClear}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  <IconButton onClick={handleSearch}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1%",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleAddRow}>
            اضف مشرف
          </Button>
        </div>

        <Box
          sx={{
            height: "67%",
            width: "100%",
          }}
        >
          <DataGrid
            style={{ background: "#f3f3f3" }}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            loading={isLoading}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 8,
                },
              },
            }}
            pageSizeOptions={[8]}
            paginationMode="server"
            rowCount={totalRecords}
            disableRowSelectionOnClick
            // onPaginationModelChange={handlePaginationChange}
            onPaginationModelChange={(model) => {
              setIsLoading(true); // عند بدء تحميل الصفحة، تفعيل حالة التحميل
              handlePaginationChange(model);
              setIsLoading(false); // إلغاء حالة التحميل بعد استرجاع البيانات
            }}
            disableColumnFilter={true}
            disableColumnSelector={true}
            disableColumnMenu={true}
            disableColumnSorting={true}
            autoHeight={true}
            localeText={{
              noRowsLabel: "",
            }}
            sx={{
              "& .MuiTablePagination-actions > button": {
                transform: "rotate(180deg)",
              },
              "& .MuiDataGrid-columnHeaders": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-cell": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-footerContainer": {
                justifyContent: "flex-start",
              },
              "& .MuiTablePagination-toolbar": {
                direction: "rtl",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
            }}
          />
        </Box>
        {modalOpen && (
          <UserModal userId={selectedUserId} onClose={handleCloseModal} />
        )}
        {addUserModalOpen && (
          <AddUserModal
            onClose={handleCloseAddUserModal}
            onSubmit={fetchData}
          />
        )}
        {editUserModalOpen && (
          <EditUserModal
            userId={selectedUserId}
            onClose={handleCloseEditUserModal}
            onSubmit={fetchData}
          />
        )}
        {showConfirm && (
          <DeleteConfirmation
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            nameUser={nameToDelete}
          />
        )}
      </div>
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import { DataGrid } from "@mui/x-data-grid";
// import { IconButton } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import UserModal from "./UserModal";

// export default function ManageUsers() {
//   const [rows, setRows] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(0);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);

//   const handlePaginationChange = (paginationModel) => {
//     setCurrentPage(paginationModel.page);
//   };

//   //   useEffect(() => {
//   //     const fetchData = async () => {
//   //       const token = localStorage.getItem("token");

//   //       if (!token) {
//   //         console.error("Token is missing, redirecting to login.");
//   //         navigate("/login");
//   //         return;
//   //       }

//   //       try {
//   //         const response = await axios.get(
//   //           `https://webapplication120240901063509.azurewebsites.net/api/User/GetAllByPage/${
//   //             currentPage + 1
//   //           }`,
//   //           {
//   //             headers: {
//   //               Authorization: `Bearer ${token}`,
//   //             },
//   //           }
//   //         );

//   //         const formattedData = response.data.users.map((user) => ({
//   //           id: user.id,
//   //           fullName: user.fullName,
//   //           userName: user.userName,
//   //         }));

//   //         setRows(formattedData);
//   //         setTotalRecords(response.data.allRecord);
//   //       } catch (error) {
//   //         console.error("Error fetching data:", error);
//   //       }
//   //     };

//   //     fetchData();
//   //   }, [currentPage, navigate]);

//   const handleDelete = (id) => {
//     const storedUserId = Number(localStorage.getItem("userID"));

//     if (id === storedUserId) {
//       alert(`You are connected to more than one table ${id}`);
//     } else {
//       alert(`You do not have permission to Delete User ${id}`);
//     }
//   };

//   const handleEdit = (id) => {
//     const storedUserId = Number(localStorage.getItem("userID"));

//     if (id === storedUserId) {
//       navigate("/infoUser");
//     } else {
//       alert(`You do not have permission to Edit User ${id}`);
//     }
//   };

//   const handleView = (id) => {
//     setSelectedUserId(id);
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setSelectedUserId(null);
//   };

//   const handleAddRow = () => {
//     alert(`You do not have permission to Add New User`);
//   };

//   const columns = [
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 1,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleView(params.row.id)}>
//             <VisibilityIcon />
//           </IconButton>
//           <IconButton
//             color="secondary"
//             onClick={() => handleEdit(params.row.id)}
//           >
//             <EditIcon />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
//             <DeleteIcon />
//           </IconButton>
//         </>
//       ),
//     },

//     {
//       field: "userName",
//       headerName: "User Name",
//       flex: 1.5,
//     },

//     {
//       field: "fullName",
//       headerName: "Full Name",
//       flex: 1.5,
//     },
//     { field: "id", headerName: "ID", flex: 0.5 },
//   ];

//   return (
//     <div
//       dir={"ltr"}
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         marginTop: "7%",
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "flex-start",
//           marginBottom: "1%",
//         }}
//       >
//         <Button variant="contained" color="primary" onClick={handleAddRow}>
//           Add User
//         </Button>
//       </div>

//       <Box
//         sx={{
//           height: "67%",
//           width: "100%",
//         }}
//       >
//         <DataGrid
//           style={{ background: "#e6e6e6" }}
//           rows={rows}
//           columns={columns}
//           getRowId={(row) => row.id}
//           initialState={{
//             pagination: {
//               paginationModel: {
//                 pageSize: 10,
//               },
//             },
//           }}
//           pageSizeOptions={[10]}
//           paginationMode="server"
//           rowCount={totalRecords}
//           disableRowSelectionOnClick
//           onPaginationModelChange={handlePaginationChange}
//         />
//       </Box>
//       {modalOpen && (
//         <UserModal userId={selectedUserId} onClose={handleCloseModal} />
//       )}
//     </div>
//   );
// }
